import {getStartOfWeek} from './getStartOfWeek'
import type {FirstDayOfWeek} from '../../@types/date'
import dayjs from 'dayjs'

export function getMonthDays(
    month: Date,
    firstDayOfWeek: FirstDayOfWeek = 'saturday'
): Date[][] {
    // console.log(dayjs(month).format('YYYY-MM-DD'));
    // const currentMonth = month.getMonth()
    const now = dayjs(month).calendar('jalali');
    // const currentMonth = now.month();
    // alert(currentMonth)
    // const startOfMonth = new Date(month.getFullYear(), currentMonth, 1)
    const startOfMonth = now.calendar('jalali').startOf('month').toDate();
    // console.log(startOfMonth)
    // alert(startOfMonth)
    // const endOfMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0)
    const endOfMonth = now.calendar('jalali').endOf('month').toDate();
    // const endDate = getEndOfWeek(endOfMonth, firstDayOfWeek)
    const endDate = dayjs(endOfMonth, {jalali: true}).calendar('jalali').endOf('week').toDate();
    // console.log('startOfMonth', dayjs(startOfMonth, {jalali: true}).calendar('jalali').format('YYYY-MM-DD'));
    // console.log('endOfMonth', dayjs(endOfMonth, {jalali: true}).calendar('jalali').format('YYYY-MM-DD'));
    // const date = getStartOfWeek(startOfMonth, firstDayOfWeek)
    const date =  dayjs(startOfMonth, {jalali: true}).calendar('jalali').startOf('week').toDate();
    const weeks = []

    // alert(dayjs(date).calendar('jalali').format('YYYY/MM/DD'))
    // alert(dayjs(endDate).calendar('jalali').format('YYYY/MM/DD'))

    while (date <= endDate) {
        const days = []

        for (let i = 0; i < 7; i += 1) {
            days.push(new Date(date))
            date.setDate(date.getDate() + 1)
            // console.log(dayjs(date).calendar('jalali').format('YYYY-MM-DD'));

        }

        weeks.push(days)
    }

    return weeks
}
